export default __webpack_public_path__ + "static/media/facial_40.9fdf9296.jpg";